package de.connect2x.timmy.web

import de.connect2x.messenger.compose.view.startMessenger
import de.connect2x.timmy.GlobalCustomConfig
import de.connect2x.timmy.loadConfig
import de.connect2x.timmy.setFavicon
import de.connect2x.timmy.setTitle
import de.connect2x.timmy.timmyConfiguration
import io.github.oshai.kotlinlogging.KotlinLoggingConfiguration
import io.ktor.http.*
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.launch
import web.location.location

suspend fun main(): Unit =
    coroutineScope {
        val config = loadConfig()
        setFavicon(config.brand.faviconPath)
        setTitle(config.brand.appName)
        GlobalCustomConfig.CSV_EXPORT_DISABLED = config.csvExportDisabled
        GlobalCustomConfig.filePreviewDisabled = config.filePreviewDisabled
        launch {
            startMessenger(
                configuration = timmyConfiguration(
                    overrideVzdUrl = Url(config.vzdUrl),
                    overrideIdpUrl = Url(config.idpUrl),
                    overrideVersionCheckUrl = Url(config.versionCheckUrl),
                    overrideHomeServerUrl = config.homeServerUrl,
                    disableDownloads = config.downloadsDisabled,
                    customConfig = {
                        urlProtocol = location.protocol.dropLast(1)
                        urlHost = location.host
                        messengerConfiguration {
                            ssoRedirectPath = "sso.html"
                        }
                        also {
                            // KotlinLoggingLevelConfiguration.logLevel is set to DEBUG in startMessenger()
                            // in startMessenger.kt. We must set logLevel here, in order ensure, that it is not
                            // overwritten later.
                            KotlinLoggingConfiguration.logLevel = config.logLevel
                        }
                    },
                    branding = config.brand
                ),
            )
        }
    }

